<template>
  <CBox
    :bg="['none', 'var(--colors-light-primary-light-gray)']"
    minHeight="100vh"
    width="100%"
    overflowX="hidden"
  >
    <OmtLayoutContainer>
      <OmtRow v-if="error">
        <HealthListEmpty
          icon="file-waveform"
          :title="error"
          text="Tente novamente em alguns instantes."
        />
      </OmtRow>
      <OmtRow v-else-if="carregado && !cards.length">
        <HealthListEmpty
          icon="file-waveform"
          title="Nenhum resumo por enquanto"
          text="Seus resumos de saúde aparecem aqui assim que forem gerados."
        />
      </OmtRow>

      <template v-else-if="cards.length">
        <OmtRow mt="16px">
          <OmtTypography
            as="p2"
            color="var(--colors-light-primary-gray2)"
          >
            {{ cards.length }} {{ cards.length === 1 ? "resumo" : "resumos" }}
          </OmtTypography>
        </OmtRow>
        <OmtRow
          v-for="card in cards"
          :key="card.id"
          mt="12px"
        >
          <HealthRecordCard
            v-bind="card.props"
            @click="abrirDetalhe(card.id)"
          />
        </OmtRow>
      </template>
    </OmtLayoutContainer>
  </CBox>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { CBox } from "@chakra-ui/vue";
import HealthListEmpty from "@/components/Organisms/Wellness/HealthListEmpty.vue";
import HealthRecordCard from "@/components/Organisms/Wellness/HealthRecordCard.vue";
import scrollbarVisivel from "@/mixins/scrollbarVisivel";

export default {
  name: "InsightsSaudeList",
  components: { CBox, HealthListEmpty, HealthRecordCard },
  mixins: [scrollbarVisivel],
  data() {
    return {
      carregado: false,
      error: null
    };
  },
  computed: {
    ...mapState("insightsSaude", ["insights"]),
    cards() {
      // A API ja devolve do mais recente para o mais antigo.
      return (this.insights || []).map((insight, idx) => ({
        id: insight.Id,
        props: {
          title: `Insight de Saúde - ${insight.DiaResumo}`,
          description: insight.Resumo,
          icon: "heartbeat",
          highlight: idx === 0 ? "Mais recente" : ""
        }
      }));
    }
  },
  async mounted() {
    this.$root.$emit("show-loading");
    try {
      await this.listInsights();
    } catch (error) {
      console.error(error);
      this.error = "Serviço temporariamente indisponível";
    } finally {
      this.carregado = true;
      this.$root.$emit("hide-loading");
    }
  },
  methods: {
    ...mapActions("insightsSaude", ["listInsights"]),
    abrirDetalhe(id) {
      this.$router.push({ name: "insightsSaude.detalhe", params: { id } });
    }
  }
};
</script>
